import React, { FC } from 'react';

import { sizeListViewedEvent } from '../../../../../../common/models/TrackingEvents';
import { track } from '../../../../../../helpers/tracking/tracking';
import { SelectedSize } from '../../../types/SelectedSize';
import { SelectorOption } from '../../../types/SelectorOption';

import { SizeSelectorDesktop } from './SizeSelectorDesktop';
import { SizeSelectorMobile } from './SizeSelectorMobile';

export const SizeSelector: FC<{
  isOutOfStock?: boolean;
  selectedSize: SelectedSize;
  selectorOptions: SelectorOption[];
  selectorTitleText: string;
  setSelectedSize: (val: SelectedSize) => void;
  sizeSystem: string;
  sizeSystemAlias: string;
}> = ({
  isOutOfStock,
  selectedSize,
  setSelectedSize,
  selectorOptions,
  selectorTitleText,
  sizeSystem,
  sizeSystemAlias,
}) => {
  const onSelectorClick = () => {
    track(sizeListViewedEvent, {
      ui: {
        sizesList: selectorOptions.map(el => el.size),
        sizeSystem,
      },
    });
  };

  const selectSize = (size: string) => {
    setSelectedSize({
      selected: size,
      selectedOption: selectorOptions.find(option => option.value === size),
      showSelectSizeBadge: false,
    });
  };

  return (
    <>
      <SizeSelectorDesktop
        isOutOfStock={isOutOfStock}
        selectedOption={selectedSize.selectedOption}
        selectorOptions={selectorOptions}
        selectorTitleText={selectorTitleText}
        selectSize={selectSize}
        showSelectSizeBadge={selectedSize.showSelectSizeBadge}
        sizeSystemAlias={sizeSystemAlias}
        trackOnSelectorClick={onSelectorClick}
      />
      <SizeSelectorMobile
        isOutOfStock={isOutOfStock}
        selectedOption={selectedSize.selectedOption}
        selectorOptions={selectorOptions}
        selectorTitleText={selectorTitleText}
        selectSize={selectSize}
        sizeSystemAlias={sizeSystemAlias}
        trackOnSelectorClick={onSelectorClick}
      />
    </>
  );
};
